import {
    useEffect,
    useState,
} from 'react';

import {Autocomplete,} from '@mantine/core';

import {useCustomers} from '../hooks/useCustomers.ts';
import {Customer} from '../types';
import {FieldProps} from 'formik';
import {useAuth} from "../../../hooks/useAuth.ts";

export const CustomersAutocomplete = ({
                                          field: {
                                              name,
                                              value: fieldValue,
                                          },
                                          form: {setFieldValue},
                                          ...rest
                                      }: FieldProps) => {

    const {user} = useAuth()

    if (!user) {
        throw new Error('user is required parameter')
    }

    const {items: records, fetchRecords} = useCustomers();

    const [value, setValue] = useState('');
    const [disabled, setDisabled] = useState(false);

    useEffect(() => {
        fetchRecords();
    }, []);

    const data = records.map((record: Customer) => {
        return {
            ...record,
            label: record.name || record.id,
            value: record.name || record.id,
        };
    });

    useEffect(() => {
        if (records.length === 0) {
            setDisabled(true);
        } else {
            setDisabled(false);
        }

        const found = records.find((item: Customer) => item.id === fieldValue);
        if (typeof found !== 'undefined' && Object.prototype.hasOwnProperty.call(found, 'name')) {
            setValue(found.name as string);
        }
    }, [records.length]);

    const handleChange = (value: string) => {
        if (!Array.isArray(data)) {
            throw new Error('Data is expected to be an array');
        }
        const {id} = data.find((item) => item.name === value) || {};

        if (typeof id !== 'undefined') {
            setFieldValue(name, id);
        }

        setValue(value);
    };

    return (
        <Autocomplete
            name={name}
            value={value}
            onChange={handleChange}
            data={data}
            disabled={disabled}
            placeholder='Select Customer'
            {...rest}
        />
    );
};
